<div class="user-list-main mb-5 app-scrollbar">
  <div class="row pt-4 mx-2 item">
    <div class="col-1 m-auto">
      <img src="assets/svg/ico-lock-circle.svg" alt="home icon" />
    </div>
    <div class="col-5 d-flex align-items-center">
      <div class="pt-1 pl-2">
        <span class="count pr-10">
          {{ totalIssuesCount }}
        </span>
      </div>
      <div class="pt-6 col-12">
        <p class="heading">{{ "ACTIVE_ISSUE" | translate }}</p>
      </div>
    </div>

    <div
      class="col-5 d-flex px-3 pl-5 text-right align-self-center justify-content-end"
    ></div>
  </div>

  <div class="row mx-2">
    <hr class="col-10 offset-1 divider mr-2" />
  </div>
  <div class="card-view-primary-box content pb-4 position-relative mb-4">
    <div
      class="row my-2 mx-4 sticky-search-filter d-flex justify-content-between"
    >
      <app-search-field
        class="col-10"
        (searchCriteria)="searchThis($event)"
      ></app-search-field>
      <div class="col-2 text-right">
        <span class="position-relative">
          <img
            class="col-auto menu-icon pointer-cursor"
            src="assets/svg/ico-menu-circle.svg"
            (click)="selectFilter()"
          />
          <span class="mf-badge" *ngIf="filterCount !== 0">
            <span class="circle-content">
              {{ filterCount || "" }}
            </span>
          </span>
        </span>
      </div>
    </div>

    <div class="mt-4 main-containter">
      <ng-container
        *ngIf="!searchKeyPress && activeIssuesList$ as activeIssuesList"
      >
        <ng-container *ngIf="activeIssuesList.length > 0">
          <ng-container
            *ngFor="
              let activeIssue of activeIssuesList | orderBy : 'timestamp';
              let i = index;
              trackBy: trackByActiveIssues
            "
          >
            <a
              class="user-item"
              routerLinkActive="active"
              [routerLink]="
                activeIssue.unitId
                  ? navigateToUnitDetail(activeIssue)
                  : navigateToAccessPointDetail(activeIssue)
              "
            >
              <div
                class="py-2 mx-1 item pointer-cursor d-flex justify-content-between align-items-center"
              >
                <div
                  class="d-flex flex-row justify-content-start item-left-section"
                >
                  <ng-container [ngSwitch]="activeIssue?.eventDescription">
                    <ng-container *ngSwitchCase="CONSTANTS.FIRMWARE_UPDATE">
                      <img
                        src="assets/svg/ico-alert-red-circle.svg"
                        alt="critical icon"
                      />
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <img
                        src="assets/svg/ico-alert-red-circle.svg"
                        alt="critical icon"
                      />
                    </ng-container>
                  </ng-container>
                  <div class="pl-4 item-text-section">
                    <div
                      class="col-12 heading3"
                      [title]="activeIssue?.deviceName"
                    >
                      {{ activeIssue?.deviceName }}
                    </div>
                    <div class="col-12 status">
                      {{ "UNIT" | translate }} {{ activeIssue?.unitPrefix || ""
                      }}{{ activeIssue?.unitName }},
                      {{ "BUILDING" | translate }}
                      {{ activeIssue?.buildingName }}
                    </div>
                    <span class="col-12 date">
                      <ng-container *ngIf="activeIssue?.isoTime">
                        {{
                          getContentFormatDate(
                            activeIssue?.isoTime,
                            "MMM do, yyyy h:mm a"
                          )
                        }}
                      </ng-container>
                    </span>
                  </div>
                </div>

                <div
                  class="ml-3 d-flex align-items-center align-self-center justify-content-end flex-shrink-0 item-right-section"
                >
                  <div class="time text-right">
                    {{ activeIssue?.eventDescription }}
                  </div>
                  <div class="align-self-center ml-2">
                    <img
                      src="assets/svg/ico-chevron-forward-outline.svg"
                      alt="forward icon"
                    />
                  </div>
                </div>
              </div>
            </a>
          </ng-container>
        </ng-container>

        <!-- View More Button -->
        <div
          class="view-more"
          *ngIf="activeIssuesList.length < totalIssuesCount && !isFetching"
        >
          <p class="view-all-btn mt-1 mb-0 pointer-cursor" (click)="loadMore()">
            {{ "VIEW_MORE" | translate }} ({{ activeIssuesList.length }} /
            {{ totalIssuesCount }})
          </p>
        </div>
      </ng-container>

      <!-- Loader for fetching -->
      <div *ngIf="isFetching" class="centered">
        <app-nested-loader></app-nested-loader>
      </div>

      <ng-container
        *ngIf="!searchKeyPress && activeIssuesList$ as activeIssuesList"
      >
        <ng-container *ngIf="activeIssuesList.length < 1">
          <div
            class="mx-xs-3 d-flex flex-column justify-content-center align-items-center sub-container"
          >
            <div class="text-container">
              <div class="icon-container ml-auto mr-auto mb-3">
                <img
                  src="assets/svg/ico-lock-circle-outline-white.svg"
                  class="lock-icon"
                />
              </div>
              <div class="text-center mb-4 mt-auto">
                <p class="empty-box">
                  {{ "NO_LOCK_IN_THIS_SITE" | translate }}
                </p>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>
